export const getAllObjectValuesByKey: any = (obj: Record<string, any>, keyToFind: string) => Object.entries(obj)
  .reduce((acc, [key, value]) => (key === keyToFind)
    ? acc.concat(value)
    : (typeof value === 'object' && value)
      ? acc.concat(getAllObjectValuesByKey(value, keyToFind))
      : acc
  , []);
